export default __webpack_public_path__ + "static/media/spill.5cb7a093.png";